<template>
  <!-- Sign Up Layout -->
  <div class="admin-login">
      <b-container fluid="lg">
          <b-row no-gutters>
              <b-col cols="12" md="6">
                  <b-card no-body class="text-white border-0 bg-transparent card-image">
                      <img class="card-img shadow-sm w-100" src="../../assets/images/cadastroResp.png"
                          alt="Card image" width="445" height="650" />
                      <div class="card-img-overlay border-rad">
                          <div>
                              <div class="logo-header mb-5">
                                  <img src="/images/sistemacpv_white.png" alt="Card image" width="110px"
                                      height="auto" />
                                  <!-- <b-img src="/images/sistemacpv_white.png" alt="Sistema CPV"></b-img> -->
                              </div>

                              <div class="p-3 d-flex flex-column">
                                  <div class="text-center">
                                      <h2 class="text-white fw-700 text-uppercase">Bem Vindo</h2>
                                  </div>

                                  <p class="text-white">
                                      Para poder se cadastrar como <strong>Colaborador</strong> você deve ter o
                                      <strong>Código da Escola</strong> e
                                      também ter código de:
                                  </p>
                                  <ul class="ml-4">
                                      <li>Professor</li>
                                      <li>ou Diretor</li>
                                      <li>ou Coordenador</li>
                                      <li>ou Secretário(a)</li>
                                  </ul>
                                  <p class="text-white mt-3">
                                      Caso não saiba, por favor, solicitar a coordenação da instituição onde foi feito
                                      o <strong>Cadastro e habilitação</strong>
                                      para o Sistema CPV.
                                  </p>

                                  <div class="sign-up-using text-center w-100 mt-4">
                                      <h4 class="text-white mb-4">Cadastre-se usando:</h4>
                                      <ul class="list-inline">
                                          <li class="list-inline-item mx-2">
                                              <a href="javascript:void(0)" class="square-50 bg-facebook">
                                                  <i class="fab fa-facebook-f fa-inverse fa-xl"></i>
                                              </a>
                                          </li>
                                          <li class="list-inline-item mx-2">
                                              <a href="javascript:void(0)" class="square-50 bg-twitter">
                                                  <i class="fab fa-twitter fa-inverse fa-xl"></i>
                                              </a>
                                          </li>
                                          <li class="list-inline-item mx-2">
                                              <a href="javascript:void(0)" class="square-50 bg-google">
                                                  <i class="fab fa-google-plus-g fa-inverse fa-xl"></i>
                                              </a>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </b-card>
              </b-col>
              <b-col cols="12" md="6" class="d-flex align-items-center">
                  <b-card no-boddy class="shadow-sm card-form">
                      <form class="session-form" action="javascript:void(0)" method="post">
                          <div class="social-widget">
                              <h4 class="text-capitalize font-2x mb-2" v-if="!cad_codigos">&nbsp;</h4>
                              <h4 class=" font-2x mb-4" v-if="cad_codigos">&nbsp;</h4>
                          </div>
                          <b-form-row v-if="!cad_codigos" no-gutters>
                              <b-col cols="12" xl="6" class="mb-2 form-group">
                                  <label for="nomeCompleto">Nome: <span class="text-danger">*</span></label>
                                  <b-form-input id="nomeCompleto" size="sm" type="text" v-model="nome"
                                      required></b-form-input>
                                  <i class="text-danger text-error" v-if="$v.nome.$error == true">Nome é
                                      obrigatório.</i>
                              </b-col>
                              <b-col cols="12" xl="6" class="mb-2 form-group">
                                  <label for="sobrenome">Sobrenome: <span class="text-danger">*</span></label>
                                  <b-form-input id="sobrenome" size="sm" type="text" v-model="sobrenome"
                                      required></b-form-input>
                                  <i class="text-danger text-error" v-if="$v.sobrenome.$error == true">Sobrenome é
                                      obrigatório.</i>
                              </b-col>
                              <b-col cols="12" xl="5" class="mb-2 pr-1 form-group">
                                  <label for="cpf">CPF: <span class="text-danger">*</span></label>
                                  <b-input-group>
                                      <b-form-input id="cpf" size="sm" type="text" v-model="cpf"
                                          v-mask="'###.###.###-##'" required></b-form-input>
                                      <b-input-group-append is-text class="append append-cpf">
                                          <i class="fa-regular fa-address-card"></i>
                                      </b-input-group-append>
                                  </b-input-group>
                                  <i class="text-danger text-error" v-if="$v.cpf.$error == true">CPF é
                                      obrigatório.</i>
                                  <i class="text-danger text-error" v-if="checkCpf == false && cpf != ''">CPF não é
                                      valido.</i>
                              </b-col>
                              <b-col cols="12" xl="7" class="mb-2 pl-1 form-group">
                                  <label for="email">E-mail: <span class="text-danger">*</span></label>
                                  <b-input-group>
                                      <b-form-input id="email" size="sm" type="email" v-model="email"
                                          required></b-form-input>
                                      <b-input-group-append is-text class="append">
                                          <i class="fa-regular fa-envelope"></i>
                                      </b-input-group-append>
                                  </b-input-group>
                                  <i class="text-danger text-error" v-if="$v.email.$error == true">E-mail é
                                      obrigatório.</i>
                                  <i class="text-danger text-error"
                                      v-if="$v.email.$invalid == true && email.length > 3">Digite um e-mail
                                      valido.</i>
                              </b-col>
                              <b-col cols="12" lg="6" class="mb-2 form-group">
                                  <label for="password">Senha: <span class="text-danger">*</span></label>
                                  <b-form-input id="password" size="sm" :type="chk" v-model="password"
                                      required></b-form-input>
                                  <i class="text-danger text-error" v-if="$v.password.$error == true">Campo
                                      obrigatório.</i>
                              </b-col>
                              <b-col cols="12" lg="6" class="mb-2 form-group">
                                  <label for="confirmPassword">Confirmar Senha: <span
                                          class="text-danger">*</span></label>
                                  <b-input-group>
                                      <b-form-input id="confirmPassword" size="sm" :type="chk" v-model="c_password"
                                          required></b-form-input>
                                      <b-input-group-append is-text @click="showPassword" class="append show-password">
                                          <i
                                              :class="chk === 'password' ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'"></i>
                                      </b-input-group-append>
                                  </b-input-group>
                                  <i class="text-danger text-error" v-if="!$v.c_password.sameAsPassword">As senhas não
                                      são iguais.</i>
                              </b-col>
                          </b-form-row>

                          <b-row v-if="cad_codigos" class="fade-in-up wow">
                              <b-col cols="12" xl="6" class="mb-2 form-group">
                                  <label for="input-nome">Código da Escola: <span class="text-danger">*</span></label>
                                  <b-input-group>
                                      <b-form-input type="text" required v-model="codigo_escola" v-mask="'##########'"
                                          size="sm" />
                                      <b-input-group-append is-text class="append">
                                          <i class="fa-regular fa-school"></i>
                                      </b-input-group-append>
                                  </b-input-group>
                                  <i class="text-danger text-error"
                                      v-if="$v.codigo_escola.$error == true && codigo_escola != ''">
                                      * Código da escola é obrigátorio!
                                  </i>
                              </b-col>
                              <b-col cols="12" xl="6" class="mb-3 form-group">
                                  <label for="input-nome">Código do Aluno(a): <span
                                          class="text-danger">*</span></label>
                                  <b-input-group>
                                      <b-form-input type="text" required v-model="codigo_alu" v-mask="'##########'" />
                                      <b-input-group-append is-text class="append">
                                          <i class="fa-regular fa-user"></i>
                                      </b-input-group-append>
                                  </b-input-group>
                                  <i class="text-danger text-error"
                                      v-if="$v.codigo_alu.$error == true && codigo_alu !== ''">
                                      * Código do aluno é obrigátorio!
                                  </i>
                              </b-col>
                              <b-col cols="12">
                                  <b-form-checkbox class="btn-aceite" v-model="chk_aceite">
                                      <span>Concordo com os <a href="#">Termos de uso</a> e
                                          <a href="#">Política de privacidade</a> do
                                          Sistema CPV</span>
                                  </b-form-checkbox>
                              </b-col>
                          </b-row>

                          <b-row class="mt-4">
                              <b-col cols="12" class="d-flex aling-items-center">
                                  <b-button type="button" class="btn-simple p-0 d-flex aling-items-center"
                                      :to="{ name: 'cadastro' }" variant="transparent"><i
                                          class="fa-regular fa-arrow-rotate-left mr-1"></i> Voltar</b-button>
                                  <b-button type="button" class="btn-sistemacpv ml-auto" variant="transparent"
                                      @click="next()" v-if="!cad_codigos">Avançar</b-button>
                                  <b-button type="button" class="btn-sistemacpv ml-auto" variant="transparent"
                                      @click="register()" v-else-if="chk_aceite">Cadastrar</b-button>
                              </b-col>
                          </b-row>

                          <hr>

                          <b-row class="mt-4">
                              <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center">
                                  <div class="btn-simple">
                                      <span class="d-block">Já é cadastrado?</span>
                                  </div>
                                  <b-button class="btn-simple p-0 mt-1" :to="{ name: 'login' }"
                                      variant="transparent"><i
                                          class="fa-regular fa-arrow-left-to-bracket mr-1"></i>Login</b-button>
                              </b-col>
                          </b-row>
                      </form>
                  </b-card>
              </b-col>
          </b-row>
      </b-container>
  </div>
</template>

<script>
import { WOW } from 'wowjs';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { cpf } from 'cpf-cnpj-validator';
export default {
  name: 'blank',
  data() {
      return {
          cad_codigos: false,
          nome: '',
          sobrenome: '',
          chk: 'password',
          c_chk: 'password',
          password: '',
          c_password: '',
          codigo_escola: '@',
          codigo_alu: '@',
          cpf: '',
          email: '',
          chk_aceite: '@',
      };
  },

  validations: {
      nome: {
          required,
      },
      sobrenome: {
          required,
      },
      cpf: {
          required,
      },
      email: {
          required,
          email,
      },
      password: {
          required,
          minLength: minLength(8),
      },
      c_password: {
          sameAsPassword: sameAs('password'),
      },
      codigo_escola: {
          required,
      },
      codigo_alu: {
          required,
      },
  },

  creadted() {
      this.showPassword();
  },

  mounted() {
      new WOW().init();
  },

  computed: {
      checkCpf() {
          return cpf.isValid(this.cpf);
      },
  },

  methods: {
      showPassword() {
          // Alterna o tipo do campo de senha entre 'password' e 'text'
          this.chk = this.chk === 'password' ? 'text' : 'password';
      },
      showConfirmPassword() {
          // Alterna o tipo do campo de senha entre 'password' e 'text'
          this.c_chk = this.c_chk === 'password' ? 'text' : 'password';
      },
      next() {
          this.$v.$touch();
          if (this.$v.$invalid || this.checkCpf === false || this.password != this.c_password) {
              return;
          }
          this.cad_codigos = true;
          this.codigo_escola = '';
          this.codigo_alu = '';
          this.chk_aceite = '';
      },

      register() {
          this.$v.$touch();
          if (this.$v.$invalid) {
              return;
          }
          alert('SUCCESS!! :-)');
      },
  },
};
</script>